import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { MachineActivityService } from '../_services';
import * as MachineActivityActions from '../_actions/machineActivity';

@Injectable({
  providedIn: 'root',
})
export class MachineActivityEffects {
  loadMachineActivities$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MachineActivityActions.loadMachineActivities),
      mergeMap(() =>
        this.machineActivityService.getMachineActivities().pipe(
          map((machineActivities) =>
            MachineActivityActions.loadMachineActivitiesSuccess({ machineActivities })
          ),
          catchError((error) => of(MachineActivityActions.loadMachineActivitiesFailure({ error })))
        )
      )
    )
  );

  addMachineActivity$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MachineActivityActions.addMachineActivity),
      mergeMap(({ machineActivity }) =>
        this.machineActivityService.saveMachineActivity(machineActivity).pipe(
          map((savedMachineActivity) =>
            MachineActivityActions.addMachineActivitySuccess({
              machineActivity: savedMachineActivity,
            })
          ),
          catchError((error) => of(MachineActivityActions.addMachineActivityFailure({ error })))
        )
      )
    )
  );

  updateMachineActivity$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MachineActivityActions.updateMachineActivity),
      mergeMap(({ machineActivity }) =>
        this.machineActivityService.saveMachineActivity(machineActivity).pipe(
          map((updatedMachineActivity) =>
            MachineActivityActions.updateMachineActivitySuccess({
              machineActivity: updatedMachineActivity,
            })
          ),
          catchError((error) => of(MachineActivityActions.updateMachineActivityFailure({ error })))
        )
      )
    )
  );

  deleteMachineActivity$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MachineActivityActions.deleteMachineActivity),
      mergeMap(({ id }) =>
        this.machineActivityService.deleteMachineActivity(id).pipe(
          map(() => MachineActivityActions.deleteMachineActivitySuccess({ id })),
          catchError((error) => of(MachineActivityActions.deleteMachineActivityFailure({ error })))
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private machineActivityService: MachineActivityService
  ) {}
}
